import { defineMessages } from 'react-intl';

export default defineMessages({
  brandedReturnsPortal: {
    description: 'returnsSettings.brandedReturnsPortal',
    defaultMessage: 'Branded Returns Portal',
    id: 'HdSU1E',
  },
  brandedReturnsDescription: {
    description: 'returnsSettings.brandedReturnsDescription',
    defaultMessage: 'Add a Branded Returns Portal to your store. Simplify and automate the return process for your customers.',
    id: '+4Agpe',
  },
  returnPolicyDescription: {
    description: 'returnsSettings.returnPolicyDescription',
    defaultMessage: 'This is the message that is in your return policy page.',
    id: 'Y/57Sx',
  },
  brandedReturnsTitle: {
    description: 'Title for the branded returns expanded section',
    defaultMessage: 'Return Exceptions',
    id: 'dug/XY',
  },
  advancedReturnsTitle: {
    description: 'Title for the advanced returns section',
    defaultMessage: '{storeName} Returns & Exchanges',
    id: 'rZYNfB',
  },
  advancedReturnsDescription: {
    description: 'Description for the advanced returns section',
    defaultMessage:
      'Customize a full-service portal on your website to easily manage customer returns and exchanges, including Return Merchandise Authorization (RMA) workflows and other advanced configurable settings.',
    id: 'LuAD0t',
  },
  enhancedReturnsActivationContent: {
    description: 'Enhanced returns promotional banner description',
    defaultMessage:
      'Offer simple returns and exchanges with ShipStation’s new customized portal, for both you and your customers. Save time and retain revenue while delivering a smooth, branded experience every step of the way.',
    id: '+lmdM9',
  },
  activateButton: {
    description: 'Button to activate returns',
    defaultMessage: 'Activate',
    id: 'S74H1Y',
  },
  notSupportedTooltipMessage: {
    description: 'Tooltip message for unsupported feature',
    defaultMessage: 'This feature is not available on your subscription plan.',
    id: 'dNWE+/',
  },
  notSupportedText: {
    description: 'Text for unsupported feature',
    defaultMessage: 'Not supported',
    id: 'j+Rwyw',
  },
  deactivateLink: {
    description: 'Link to deactivate returns',
    defaultMessage: 'Deactivate',
    id: 'hl0tUE',
  },
  configureReturnStore: {
    description: 'The button used to link to the SSR return store configuration page',
    defaultMessage: 'Configure return settings',
    id: '4WEZxx',
  },
  deactivateStoreSuccess: {
    description: 'Success message for deactivating the store',
    defaultMessage: 'Returns & Exchanges have been deactivated for your store.',
    id: 'WV19zZ',
  },
  deactivateReturnsToastTitle: {
    description: 'Toast title for deactivating the store',
    defaultMessage: 'Store Deactivation',
    id: 'Z71lBz',
  },
  deactivateStoreError: {
    description: 'Error message for the deactivate returns card',
    defaultMessage: 'An error occurred while deactivating the store. Please try again.',
    id: 'uMBvND',
  },
  featureNotAvailableTooltip: {
    description: 'Tooltip for displayed on Activate button when feature is not available',
    defaultMessage: 'This feature is not available on your existing subscription plan.',
    id: 'Ugn0Ut',
  },
  standardReturnsTitle: {
    description: 'Title for standard returns section',
    defaultMessage: 'Standard Returns',
    id: 'MlqGYB',
  },
  standardReturnsDescription: {
    description: 'Description for standard returns section',
    defaultMessage: 'Generate and embed a basic returns request portal for your customers',
    id: 'kKeobh',
  },
  standardReturnsSettingsTitle: {
    description: 'Title for standard returns settings',
    defaultMessage: 'Standard Returns Settings',
    id: 'vUPHC9',
  },
  standardReturnsSettingsDescription: {
    description: 'Description for standard returns settings',
    defaultMessage: 'Generate and embed a basic returns request portal for your customers.',
    id: 'P4aXPS',
  },
});
